import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useDispatch } from 'react-redux';
import { apiClient } from '../../../utils/axios';
import { useState } from 'react';
import { AxiosError } from 'axios';

export const handleGenerateReport = async (formData) => {
  const { data } = await apiClient.post('/jobs', formData);
  return data;
};

export const useCreateReportsJobHandler = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const [loading, setLoading] = useState(false);

  const mutation = useMutation({
    mutationFn: handleGenerateReport,
    onSuccess: () => {
      dispatch(
        showSnackbar({
          message: "Report generation queued successfully!",
          severity: 'success',
        }),
      );
      queryClient.invalidateQueries({ queryKey: ['jobs'] });
    },
    onError: (error) => {
      if (error instanceof AxiosError) {
        dispatch(
          showSnackbar({
            message: error.response?.data?.message || "Error generating reports. Please try again later",
            severity: 'error',
          }),
        );
      } else {
        dispatch(
          showSnackbar({
            message: "Unexpected error occurred. Please try again.",
            severity: 'error',
          }),
        );
      }
    },
    onSettled: () => {
      setLoading(false);
    },
  });

  const onSubmit = async (data) => {
    mutation.mutate(data);
  };

  return {
    data: mutation.data,
    isError: mutation.isError,
    error: mutation.error,
    isPending: mutation.isPending || loading,
    isSuccess: mutation.isSuccess,
    onSubmit,
  };
};
